const typographyPendente = {
  name: 'Hola, Guilherme Neves Herker',
  access: 'Aún no se ha concedido su acceso',
  email: 'Recibirá un correo electrónico una vez que el administrador del sistema apruebe su acceso.',
  doubt: '¿dudas? Entre en contacto con',
  doubt1: 'ilton@adm.com'
};

export default typographyPendente;
